module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_conversation", [["div",{"class":"content-block pad-lr pad-tb conversation-block","id":"conversation-block"},[["if",{"empty":""},[["import",{"name":"site_upgrade_banner"}]],[["member.isPremium","empty",true,[],"env"]]],["div",{"class":"global-title"},[["span",{},[["textNode",{"text":"Conversation with "}],["span",{},[],[["name","__text",true,[],"client"]]]]],["div",{"class":"content-report"}]]],["div",{"class":"messages-container","id":"messages-container"},[["div",{"id":"conversation"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/conversation.tpl
// module id = 1212
// module chunks = 4